import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';
import { YouTubePlayer } from '@angular/youtube-player';
import { interval, take } from 'rxjs';

@Component({
  selector: 'app-youtube-player',
  templateUrl: './youtube-player.component.html',
  styleUrl: './youtube-player.component.scss',
  imports: [YouTubePlayer, NgClass],
})
export class YoutubePlayerComponent {
  @Input() videoId!: string;
  @Input() wide: boolean = false;
  @Input() isPreviewMode: boolean = false;

  onReady(event: YT.PlayerEvent) {
    if (event?.target?.getPlayerState() !== YT.PlayerState.UNSTARTED) {
      interval(50)
        .pipe(take(10))
        .subscribe(() => {
          this.muteVideo(event);
        });
      return;
    }
    event?.target?.mute();
    event?.target?.playVideo();
  }

  muteVideo(event: YT.PlayerEvent) {
    event?.target?.mute();
  }
}
